import { Product } from '@inter-ikea-storageone/range';

export const getInteriorSuggestionsFromRuleSet = (
  frames: number[]
): InteriorSuggestionRulesRow[] => {
  const key = buildDataSetKey(frames);
  const ruleSet = rules[key];
  return ruleSet || [];
};

export const buildDataSetKey = (frameSizes: number[]): string => {
  return frameSizes
    .sort((a, b) => b - a)
    .map(f => Math.ceil(f / 10) * 10)
    .join('-');
};

export interface InteriorSuggestionRulesRow {
  [key: string]: string[];
}

interface InteriorSuggestionRules {
  [key: string]: InteriorSuggestionRulesRow[];
}

export interface InteriorSuggestionRulesProductsRow {
  [key: string]: Product[];
}

const rules = {
  '1000-1000': [
    { '1000': ['PAX008', 'PAX008'] },
    { '1000': ['PAX001', 'PAX001'] },
    { '1000': ['PAX010', 'PAX010'] },
    { '1000': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX008'] },
    { '1000': ['PAX005', 'PAX005'] },
    { '1000': ['PAX002', 'PAX002'] },
    { '1000': ['PAX002', 'PAX008'] }
  ],
  '1000-1000-1000': [
    { '1000': ['PAX008', 'PAX008', 'PAX008'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX008', 'PAX008'] },
    { '1000': ['PAX013', 'PAX013', 'PAX013'] },
    { '1000': ['PAX001', 'PAX001', 'PAX011'] },
    { '1000': ['PAX002', 'PAX002', 'PAX002'] },
    { '1000': ['PAX002', 'PAX008', 'PAX008'] }
  ],
  '1000-1000-1000-1000': [
    { '1000': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008', 'PAX008'] },
    { '1000': ['PAX001', 'PAX001', 'PAX016', 'PAX016'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001', 'PAX001'] },
    { '1000': ['PAX001', 'PAX001', 'PAX011', 'PAX011'] },
    { '1000': ['PAX010', 'PAX010', 'PAX010', 'PAX010'] },
    { '1000': ['PAX001', 'PAX001', 'PAX002', 'PAX002'] },
    { '1000': ['PAX002', 'PAX002', 'PAX002', 'PAX002'] }
  ],
  '1000-1000-1000-1000-1000': [
    { '1000': ['PAX013', 'PAX013', 'PAX013', 'PAX013', 'PAX013'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001', 'PAX011', 'PAX011'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX013', 'PAX013', 'PAX013'] },
    { '1000': ['PAX001', 'PAX001', 'PAX002', 'PAX013', 'PAX013'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001', 'PAX002', 'PAX002'] },
    { '1000': ['PAX001', 'PAX001', 'PAX007', 'PAX008', 'PAX013'] },
    { '1000': ['PAX001', 'PAX008', 'PAX008', 'PAX008', 'PAX014'] }
  ],
  '1000-1000-1000-1000-1000-1000': [
    { '1000': ['PAX001', 'PAX001', 'PAX012', 'PAX012', 'PAX019', 'PAX019'] },
    { '1000': ['PAX007', 'PAX007', 'PAX011', 'PAX011', 'PAX016', 'PAX016'] }
  ],
  '1000-1000-1000-1000-1000-500': [
    { '1000': ['PAX001', 'PAX001', 'PAX005', 'PAX005', 'PAX011'], '500': ['PAX011'] }
  ],
  '1000-1000-1000-1000-500': [
    { '1000': ['PAX001', 'PAX001', 'PAX008', 'PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011', 'PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001', 'PAX001'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001', 'PAX001'], '500': ['PAX013'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008', 'PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX002', 'PAX002', 'PAX013', 'PAX013'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX013', 'PAX013', 'PAX013'], '500': ['PAX013'] },
    { '1000': ['PAX001', 'PAX002', 'PAX008', 'PAX010'], '500': ['PAX001'] }
  ],
  '1000-1000-1000-1000-500-500': [
    { '1000': ['PAX010', 'PAX010', 'PAX010', 'PAX010'], '500': ['PAX010', 'PAX010'] },
    { '1000': ['PAX001', 'PAX001', 'PAX011', 'PAX014'], '500': ['PAX012', 'PAX012'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001', 'PAX001'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX008', 'PAX011'], '500': ['PAX005', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX005', 'PAX022'], '500': ['PAX011', 'PAX016'] },
    { '1000': ['PAX001', 'PAX001', 'PAX002', 'PAX014'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX015', 'PAX015', 'PAX017', 'PAX017'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX001', 'PAX008', 'PAX008', 'PAX008'], '500': ['PAX011', 'PAX014'] }
  ],
  '1000-1000-1000-1000-750': [
    { '1000': ['PAX001', 'PAX001', 'PAX013', 'PAX013'], '750': ['PAX013'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011', 'PAX011'], '750': ['PAX005'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011', 'PAX011'], '750': ['PAX011'] },
    { '1000': ['PAX011', 'PAX011', 'PAX014', 'PAX014'], '750': ['PAX011'] },
    { '1000': ['PAX002', 'PAX002', 'PAX008', 'PAX015'], '750': ['PAX011'] },
    { '1000': ['PAX001', 'PAX004', 'PAX008', 'PAX008'], '750': ['PAX008'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008', 'PAX008'], '750': ['PAX011'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008', 'PAX008'], '750': ['PAX018'] }
  ],
  '1000-1000-1000-1000-750-500': [
    { '1000': ['PAX001', 'PAX001', 'PAX005', 'PAX005'], '750': ['PAX002'], '500': ['PAX013'] }
  ],
  '1000-1000-1000-500': [
    { '1000': ['PAX011', 'PAX011', 'PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX008', 'PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX001'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX008', 'PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX013', 'PAX013', 'PAX013'], '500': ['PAX013'] },
    { '1000': ['PAX008', 'PAX008', 'PAX015'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX013'], '500': ['PAX001'] },
    { '1000': ['PAX001', 'PAX002', 'PAX008'], '500': ['PAX011'] }
  ],
  '1000-1000-1000-500-500': [
    { '1000': ['PAX001', 'PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX002', 'PAX013'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002', 'PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX010'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX005', 'PAX005'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX021', 'PAX021', 'PAX021'], '500': ['PAX013', 'PAX013'] },
    { '1000': ['PAX010', 'PAX010', 'PAX010'], '500': ['PAX010', 'PAX010'] }
  ],
  '1000-1000-1000-500-500-500': [
    { '1000': ['PAX001', 'PAX001', 'PAX016'], '500': ['PAX001', 'PAX011', 'PAX016'] },
    { '1000': ['PAX001', 'PAX001', 'PAX011'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX005', 'PAX013'], '500': ['PAX011', 'PAX011', 'PAX012'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008'], '500': ['PAX001', 'PAX005', 'PAX016'] },
    { '1000': ['PAX008', 'PAX011', 'PAX016'], '500': ['PAX001', 'PAX001', 'PAX013'] },
    { '1000': ['PAX004', 'PAX008', 'PAX008'], '500': ['PAX016', 'PAX016', 'PAX016'] },
    { '1000': ['PAX002', 'PAX002', 'PAX012'], '500': ['PAX008', 'PAX012', 'PAX014'] }
  ],
  '1000-1000-1000-750': [
    { '1000': ['PAX001', 'PAX001', 'PAX001'], '750': ['PAX001'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011'], '750': ['PAX011'] },
    { '1000': ['PAX013', 'PAX013', 'PAX013'], '750': ['PAX013'] },
    { '1000': ['PAX001', 'PAX011', 'PAX011'], '750': ['PAX011'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008'], '750': ['PAX008'] },
    { '1000': ['PAX001', 'PAX008', 'PAX008'], '750': ['PAX016'] },
    { '1000': ['PAX002', 'PAX002', 'PAX011'], '750': ['PAX011'] },
    { '1000': ['PAX001', 'PAX002', 'PAX002'], '750': ['PAX001'] }
  ],
  '1000-1000-1000-750-500': [
    { '1000': ['PAX001', 'PAX006', 'PAX013'], '750': ['PAX005'], '500': ['PAX011'] },
    { '1000': ['PAX011', 'PAX011', 'PAX011'], '750': ['PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX006', 'PAX006'], '750': ['PAX006'], '500': ['PAX014'] },
    { '1000': ['PAX013', 'PAX013', 'PAX013'], '750': ['PAX013'], '500': ['PAX013'] },
    { '1000': ['PAX012', 'PAX014', 'PAX014'], '750': ['PAX016'], '500': ['PAX016'] },
    { '1000': ['PAX008', 'PAX008', 'PAX011'], '750': ['PAX011'], '500': ['PAX005'] },
    { '1000': ['PAX002', 'PAX003', 'PAX004'], '750': ['PAX016'], '500': ['PAX016'] },
    { '1000': ['PAX002', 'PAX004', 'PAX013'], '750': ['PAX002'], '500': ['PAX009'] }
  ],
  '1000-1000-1000-750-750': [
    { '1000': ['PAX001', 'PAX013', 'PAX013'], '750': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001', 'PAX021'], '750': ['PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008', 'PAX013'], '750': ['PAX011', 'PAX016'] },
    { '1000': ['PAX008', 'PAX008', 'PAX011'], '750': ['PAX001', 'PAX001'] },
    { '1000': ['PAX004', 'PAX004', 'PAX011'], '750': ['PAX008', 'PAX008'] },
    { '1000': ['PAX002', 'PAX002', 'PAX016'], '750': ['PAX013', 'PAX013'] },
    { '1000': ['PAX001', 'PAX008', 'PAX013'], '750': ['PAX011', 'PAX016'] },
    { '1000': ['PAX008', 'PAX008', 'PAX008'], '750': ['PAX008', 'PAX008'] }
  ],
  '1000-1000-500': [
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX016'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX011'] },
    { '1000': ['PAX005', 'PAX005'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX013'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX001'] },
    { '1000': ['PAX002', 'PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX002', 'PAX002'], '500': ['PAX011'] }
  ],
  '1000-1000-500-500': [
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX002', 'PAX002'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002', 'PAX002'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX012', 'PAX012'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX013', 'PAX013'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX001', 'PAX001'] }
  ],
  '1000-1000-500-500-500': [
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX001', 'PAX011', 'PAX011'] },
    { '1000': ['PAX011', 'PAX011'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '500': ['PAX011', 'PAX011', 'PAX012'] },
    { '1000': ['PAX002', 'PAX002'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX005', 'PAX011'], '500': ['PAX002', 'PAX011', 'PAX011'] },
    { '1000': ['PAX021', 'PAX021'], '500': ['PAX013', 'PAX021', 'PAX021'] }
  ],
  '1000-1000-500-500-500-500': [
    { '1000': ['PAX001', 'PAX008'], '500': ['PAX002', 'PAX016', 'PAX016', 'PAX016'] },
    { '1000': ['PAX011', 'PAX011'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX011', 'PAX011'], '500': ['PAX010', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX014', 'PAX014'], '500': ['PAX011', 'PAX011', 'PAX016', 'PAX016'] },
    { '1000': ['PAX007', 'PAX008'], '500': ['PAX006', 'PAX008', 'PAX011', 'PAX011'] },
    { '1000': ['PAX002', 'PAX002'], '500': ['PAX001', 'PAX013', 'PAX016', 'PAX016'] },
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX016', 'PAX016', 'PAX016', 'PAX016'] },
    { '1000': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] }
  ],
  '1000-1000-750': [
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX011'] },
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX016'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001'] },
    { '1000': ['PAX011', 'PAX011'], '750': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX013'] },
    { '1000': ['PAX002', 'PAX002'], '750': ['PAX016'] },
    { '1000': ['PAX002', 'PAX002'], '750': ['PAX002'] }
  ],
  '1000-1000-750-500': [
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001'], '500': ['PAX001'] },
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX011', 'PAX011'], '750': ['PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001'], '500': ['PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX016'], '500': ['PAX016'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001'], '500': ['PAX013'] },
    { '1000': ['PAX002', 'PAX002'], '750': ['PAX016'], '500': ['PAX016'] },
    { '1000': ['PAX002', 'PAX002'], '750': ['PAX001'], '500': ['PAX001'] }
  ],
  '1000-1000-750-500-500': [
    { '1000': ['PAX012', 'PAX012'], '750': ['PAX011'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX002'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX016'], '500': ['PAX011', 'PAX014'] },
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX011'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX013'], '750': ['PAX013'], '500': ['PAX001', 'PAX013'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX021'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002', 'PAX008'], '750': ['PAX011'], '500': ['PAX014', 'PAX014'] },
    { '1000': ['PAX002', 'PAX002'], '750': ['PAX014'], '500': ['PAX008', 'PAX008'] }
  ],
  '1000-1000-750-500-500-500': [
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX012'], '500': ['PAX001', 'PAX012', 'PAX014'] },
    { '1000': ['PAX013', 'PAX016'], '750': ['PAX009'], '500': ['PAX011', 'PAX011', 'PAX012'] }
  ],
  '1000-1000-750-750': [
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX016', 'PAX016'] },
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX008', 'PAX008'] },
    { '1000': ['PAX011', 'PAX011'], '750': ['PAX011', 'PAX011'] },
    { '1000': ['PAX004', 'PAX004'], '750': ['PAX016', 'PAX016'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001', 'PAX001'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX010', 'PAX010'] },
    { '1000': ['PAX008', 'PAX008'], '750': ['PAX002', 'PAX002'] }
  ],
  '1000-1000-750-750-500': [
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX011', 'PAX011'], '500': ['PAX016'] },
    { '1000': ['PAX002', 'PAX010'], '750': ['PAX008', 'PAX011'], '500': ['PAX001'] },
    { '1000': ['PAX001', 'PAX021'], '750': ['PAX016', 'PAX016'], '500': ['PAX001'] },
    { '1000': ['PAX002', 'PAX008'], '750': ['PAX011', 'PAX011'], '500': ['PAX016'] },
    { '1000': ['PAX005', 'PAX007'], '750': ['PAX011', 'PAX011'], '500': ['PAX016'] },
    { '1000': ['PAX001', 'PAX021'], '750': ['PAX021', 'PAX021'], '500': ['PAX013'] },
    { '1000': ['PAX005', 'PAX011'], '750': ['PAX011', 'PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX005', 'PAX007'], '750': ['PAX011', 'PAX011'], '500': ['PAX011'] }
  ],
  '1000-1000-750-750-500-500': [
    { '1000': ['PAX002', 'PAX021'], '750': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX013'] }
  ],
  '1000-1000-750-750-750': [
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001', 'PAX010', 'PAX010'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX001', 'PAX001', 'PAX001'] },
    { '1000': ['PAX014', 'PAX014'], '750': ['PAX014', 'PAX014', 'PAX014'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX007', 'PAX013'], '750': ['PAX008', 'PAX008', 'PAX008'] },
    { '1000': ['PAX016', 'PAX016'], '750': ['PAX001', 'PAX012', 'PAX012'] },
    { '1000': ['PAX004', 'PAX004'], '750': ['PAX002', 'PAX002', 'PAX016'] },
    { '1000': ['PAX001', 'PAX001'], '750': ['PAX002', 'PAX002', 'PAX008'] }
  ],
  '1000-1000-750-750-750-750': [
    { '1000': ['PAX013', 'PAX014'], '750': ['PAX006', 'PAX006', 'PAX006', 'PAX006'] },
    { '1000': ['PAX006', 'PAX006'], '750': ['PAX006', 'PAX006', 'PAX006', 'PAX006'] }
  ],
  '1000-500': [
    { '1000': ['PAX001'], '500': ['PAX011'] },
    { '1000': ['PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX008'], '500': ['PAX016'] },
    { '1000': ['PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX001'], '500': ['PAX001'] },
    { '1000': ['PAX010'], '500': ['PAX010'] },
    { '1000': ['PAX002'], '500': ['PAX011'] },
    { '1000': ['PAX015'], '500': ['PAX011'] }
  ],
  '1000-500-500': [
    { '1000': ['PAX001'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX011'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX017'], '500': ['PAX010', 'PAX011'] },
    { '1000': ['PAX017'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX001'], '500': ['PAX001', 'PAX013'] },
    { '1000': ['PAX010'], '500': ['PAX010', 'PAX010'] }
  ],
  '1000-500-500-500': [
    { '1000': ['PAX001'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX011'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX008'], '500': ['PAX008', 'PAX011', 'PAX011'] },
    { '1000': ['PAX008'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX002'], '500': ['PAX008', 'PAX011', 'PAX011'] },
    { '1000': ['PAX015'], '500': ['PAX008', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '500': ['PAX013', 'PAX013', 'PAX013'] },
    { '1000': ['PAX001'], '500': ['PAX001', 'PAX021', 'PAX021'] }
  ],
  '1000-500-500-500-500': [
    { '1000': ['PAX011'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '500': ['PAX011', 'PAX011', 'PAX016', 'PAX016'] },
    { '1000': ['PAX001'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX021'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX002'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX021'] },
    { '1000': ['PAX008'], '500': ['PAX008', 'PAX008', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '500': ['PAX001', 'PAX010', 'PAX010', 'PAX021'] },
    { '1000': ['PAX002'], '500': ['PAX002', 'PAX011', 'PAX011', 'PAX012'] }
  ],
  '1000-500-500-500-500-500': [
    { '1000': ['PAX004'], '500': ['PAX002', 'PAX002', 'PAX004', 'PAX016', 'PAX016'] }
  ],
  '1000-750': [
    { '1000': ['PAX008'], '750': ['PAX008'] },
    { '1000': ['PAX001'], '750': ['PAX001'] },
    { '1000': ['PAX001'], '750': ['PAX011'] },
    { '1000': ['PAX008'], '750': ['PAX011'] },
    { '1000': ['PAX011'], '750': ['PAX011'] },
    { '1000': ['PAX002'], '750': ['PAX002'] },
    { '1000': ['PAX013'], '750': ['PAX013'] },
    { '1000': ['PAX002'], '750': ['PAX008'] }
  ],
  '1000-750-500': [
    { '1000': ['PAX008'], '750': ['PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX001'], '500': ['PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX001'], '500': ['PAX001'] },
    { '1000': ['PAX011'], '750': ['PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX001'], '500': ['PAX013'] },
    { '1000': ['PAX002'], '750': ['PAX008'], '500': ['PAX011'] },
    { '1000': ['PAX002'], '750': ['PAX008'], '500': ['PAX016'] }
  ],
  '1000-750-500-500': [
    { '1000': ['PAX008'], '750': ['PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX011'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX008'], '750': ['PAX008'], '500': ['PAX016', 'PAX016'] },
    { '1000': ['PAX001'], '750': ['PAX001'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002'], '750': ['PAX002'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002'], '750': ['PAX002'], '500': ['PAX008', 'PAX008'] },
    { '1000': ['PAX021'], '750': ['PAX021'], '500': ['PAX021', 'PAX021'] },
    { '1000': ['PAX001'], '750': ['PAX001'], '500': ['PAX010', 'PAX021'] }
  ],
  '1000-750-500-500-500': [
    { '1000': ['PAX005'], '750': ['PAX009'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX008'], '750': ['PAX016'], '500': ['PAX001', 'PAX011', 'PAX011'] },
    { '1000': ['PAX004'], '750': ['PAX008'], '500': ['PAX002', 'PAX012', 'PAX012'] },
    { '1000': ['PAX002'], '750': ['PAX002'], '500': ['PAX001', 'PAX008', 'PAX016'] },
    { '1000': ['PAX014'], '750': ['PAX014'], '500': ['PAX012', 'PAX014', 'PAX014'] },
    { '1000': ['PAX011'], '750': ['PAX001'], '500': ['PAX011', 'PAX014', 'PAX016'] },
    { '1000': ['PAX011'], '750': ['PAX011'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX021'], '750': ['PAX021'], '500': ['PAX011', 'PAX011', 'PAX011'] }
  ],
  '1000-750-500-500-500-500': [
    { '1000': ['PAX008'], '750': ['PAX001'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] }
  ],
  '1000-750-750': [
    { '1000': ['PAX008'], '750': ['PAX008', 'PAX008'] },
    { '1000': ['PAX001'], '750': ['PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX001'] },
    { '1000': ['PAX001'], '750': ['PAX008', 'PAX008'] },
    { '1000': ['PAX011'], '750': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002'], '750': ['PAX001', 'PAX001'] },
    { '1000': ['PAX013'], '750': ['PAX001', 'PAX001'] },
    { '1000': ['PAX002'], '750': ['PAX008', 'PAX008'] }
  ],
  '1000-750-750-500': [
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX011'], '500': ['PAX011'] },
    { '1000': ['PAX008'], '750': ['PAX001', 'PAX001'], '500': ['PAX013'] },
    { '1000': ['PAX001'], '750': ['PAX011', 'PAX016'], '500': ['PAX012'] },
    { '1000': ['PAX001'], '750': ['PAX008', 'PAX008'], '500': ['PAX001'] },
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX013'], '500': ['PAX011'] },
    { '1000': ['PAX014'], '750': ['PAX002', 'PAX012'], '500': ['PAX011'] },
    { '1000': ['PAX006'], '750': ['PAX008', 'PAX016'], '500': ['PAX002'] },
    { '1000': ['PAX008'], '750': ['PAX001', 'PAX008'], '500': ['PAX014'] }
  ],
  '1000-750-750-500-500': [
    { '1000': ['PAX001'], '750': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX012'], '750': ['PAX008', 'PAX008'], '500': ['PAX006', 'PAX016'] },
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX013'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX011'], '750': ['PAX012', 'PAX014'], '500': ['PAX011', 'PAX011'] },
    { '1000': ['PAX002'], '750': ['PAX002', 'PAX003'], '500': ['PAX012', 'PAX012'] },
    { '1000': ['PAX008'], '750': ['PAX004', 'PAX016'], '500': ['PAX011', 'PAX013'] },
    { '1000': ['PAX008'], '750': ['PAX001', 'PAX005'], '500': ['PAX011', 'PAX013'] },
    { '1000': ['PAX016'], '750': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] }
  ],
  '1000-750-750-750': [
    { '1000': ['PAX008'], '750': ['PAX001', 'PAX008', 'PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX011', 'PAX016', 'PAX016'] },
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX001', 'PAX001'] },
    { '1000': ['PAX011'], '750': ['PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX004'], '750': ['PAX004', 'PAX016', 'PAX016'] },
    { '1000': ['PAX001'], '750': ['PAX002', 'PAX008', 'PAX008'] },
    { '1000': ['PAX001'], '750': ['PAX006', 'PAX012', 'PAX014'] },
    { '1000': ['PAX021'], '750': ['PAX021', 'PAX021', 'PAX021'] }
  ],
  '1000-750-750-750-500': [
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX001', 'PAX002'], '500': ['PAX002'] },
    { '1000': ['PAX008'], '750': ['PAX002', 'PAX008', 'PAX009'], '500': ['PAX004'] },
    { '1000': ['PAX001'], '750': ['PAX016', 'PAX016', 'PAX018'], '500': ['PAX011'] },
    { '1000': ['PAX006'], '750': ['PAX006', 'PAX006', 'PAX014'], '500': ['PAX012'] }
  ],
  '1000-750-750-750-750': [
    { '1000': ['PAX008'], '750': ['PAX001', 'PAX001', 'PAX001', 'PAX005'] },
    { '1000': ['PAX011'], '750': ['PAX005', 'PAX005', 'PAX005', 'PAX005'] },
    { '1000': ['PAX013'], '750': ['PAX005', 'PAX005', 'PAX012', 'PAX012'] },
    { '1000': ['PAX016'], '750': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '1000': ['PAX001'], '750': ['PAX008', 'PAX008', 'PAX009', 'PAX013'] },
    { '1000': ['PAX008'], '750': ['PAX001', 'PAX005', 'PAX010', 'PAX011'] },
    { '1000': ['PAX013'], '750': ['PAX005', 'PAX006', 'PAX012', 'PAX012'] },
    { '1000': ['PAX001'], '750': ['PAX001', 'PAX005', 'PAX011', 'PAX011'] }
  ],
  '500-500': [
    { '500': ['PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX011'] },
    { '500': ['PAX008', 'PAX011'] },
    { '500': ['PAX008', 'PAX016'] },
    { '500': ['PAX001', 'PAX001'] },
    { '500': ['PAX021', 'PAX021'] },
    { '500': ['PAX002', 'PAX002'] },
    { '500': ['PAX002', 'PAX011'] }
  ],
  '500-500-500': [
    { '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX016', 'PAX016'] },
    { '500': ['PAX008', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX001', 'PAX001'] },
    { '500': ['PAX021', 'PAX021', 'PAX021'] },
    { '500': ['PAX002', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX002', 'PAX011'] }
  ],
  '500-500-500-500': [
    { '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX001', 'PAX016', 'PAX016'] },
    { '500': ['PAX008', 'PAX008', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX001', 'PAX011', 'PAX011'] },
    { '500': ['PAX021', 'PAX021', 'PAX021', 'PAX021'] },
    { '500': ['PAX001', 'PAX001', 'PAX001', 'PAX001'] },
    { '500': ['PAX002', 'PAX002', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX001', 'PAX002', 'PAX002'] }
  ],
  '500-500-500-500-500': [
    { '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX021', 'PAX021', 'PAX021', 'PAX021', 'PAX021'] },
    { '500': ['PAX008', 'PAX008', 'PAX008', 'PAX008', 'PAX008'] },
    { '500': ['PAX008', 'PAX008', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX001', 'PAX002', 'PAX011', 'PAX011'] },
    { '500': ['PAX013', 'PAX013', 'PAX013', 'PAX013', 'PAX013'] },
    { '500': ['PAX004', 'PAX008', 'PAX008', 'PAX014', 'PAX016'] }
  ],
  '500-500-500-500-500-500': [
    { '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX010', 'PAX010', 'PAX010', 'PAX010', 'PAX010', 'PAX010'] },
    { '500': ['PAX005', 'PAX005', 'PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX008', 'PAX008', 'PAX008', 'PAX008', 'PAX013', 'PAX016'] },
    { '500': ['PAX002', 'PAX002', 'PAX011', 'PAX011', 'PAX011', 'PAX014'] },
    { '500': ['PAX005', 'PAX005', 'PAX005', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX001', 'PAX001', 'PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '500': ['PAX005', 'PAX005', 'PAX005', 'PAX005', 'PAX011', 'PAX011'] }
  ],
  '750-500': [
    { '750': ['PAX011'], '500': ['PAX011'] },
    { '750': ['PAX001'], '500': ['PAX011'] },
    { '750': ['PAX008'], '500': ['PAX008'] },
    { '750': ['PAX008'], '500': ['PAX011'] },
    { '750': ['PAX001'], '500': ['PAX001'] },
    { '750': ['PAX021'], '500': ['PAX021'] },
    { '750': ['PAX002'], '500': ['PAX008'] },
    { '750': ['PAX002'], '500': ['PAX011'] }
  ],
  '750-500-500': [
    { '750': ['PAX001'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001'], '500': ['PAX016', 'PAX016'] },
    { '750': ['PAX008'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX011'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001'], '500': ['PAX001', 'PAX001'] },
    { '750': ['PAX002'], '500': ['PAX011', 'PAX013'] },
    { '750': ['PAX002'], '500': ['PAX001', 'PAX011'] },
    { '750': ['PAX001'], '500': ['PAX001', 'PAX013'] }
  ],
  '750-500-500-500': [
    { '750': ['PAX001'], '500': ['PAX001', 'PAX016', 'PAX016'] },
    { '750': ['PAX011'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX001'], '500': ['PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX001'], '500': ['PAX011', 'PAX012', 'PAX012'] },
    { '750': ['PAX008'], '500': ['PAX008', 'PAX008', 'PAX008'] },
    { '750': ['PAX013'], '500': ['PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX022'], '500': ['PAX004', 'PAX016', 'PAX016'] },
    { '750': ['PAX008'], '500': ['PAX002', 'PAX011', 'PAX011'] }
  ],
  '750-500-500-500-500': [
    { '750': ['PAX011'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX016'], '500': ['PAX001', 'PAX001', 'PAX016', 'PAX016'] },
    { '750': ['PAX016'], '500': ['PAX001', 'PAX001', 'PAX012', 'PAX012'] },
    { '750': ['PAX001'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX001'], '500': ['PAX001', 'PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX008'], '500': ['PAX002', 'PAX002', 'PAX012', 'PAX012'] },
    { '750': ['PAX017'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX016'] },
    { '750': ['PAX011'], '500': ['PAX016', 'PAX016', 'PAX016', 'PAX016'] }
  ],
  '750-500-500-500-500-500': [
    { '750': ['PAX016'], '500': ['PAX001', 'PAX001', 'PAX008', 'PAX008', 'PAX010'] }
  ],
  '750-750': [
    { '750': ['PAX008', 'PAX008'] },
    { '750': ['PAX001', 'PAX001'] },
    { '750': ['PAX011', 'PAX011'] },
    { '750': ['PAX005', 'PAX005'] },
    { '750': ['PAX001', 'PAX008'] },
    { '750': ['PAX002', 'PAX002'] },
    { '750': ['PAX021', 'PAX021'] },
    { '750': ['PAX002', 'PAX008'] }
  ],
  '750-750-500': [
    { '750': ['PAX008', 'PAX008'], '500': ['PAX011'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX011'] },
    { '750': ['PAX011', 'PAX011'], '500': ['PAX011'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX016'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX013'] },
    { '750': ['PAX002', 'PAX002'], '500': ['PAX016'] },
    { '750': ['PAX002', 'PAX002'], '500': ['PAX011'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX001'] }
  ],
  '750-750-500-500': [
    { '750': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX016', 'PAX016'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX011', 'PAX011'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX002', 'PAX002'], '500': ['PAX008', 'PAX008'] },
    { '750': ['PAX002', 'PAX002'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX001', 'PAX013'] },
    { '750': ['PAX001', 'PAX001'], '500': ['PAX001', 'PAX001'] }
  ],
  '750-750-500-500-500': [
    { '750': ['PAX011', 'PAX011'], '500': ['PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX021', 'PAX021'], '500': ['PAX011', 'PAX018', 'PAX018'] },
    { '750': ['PAX001', 'PAX008'], '500': ['PAX001', 'PAX008', 'PAX014'] },
    { '750': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011', 'PAX013'] },
    { '750': ['PAX002', 'PAX003'], '500': ['PAX001', 'PAX004', 'PAX017'] },
    { '750': ['PAX008', 'PAX015'], '500': ['PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX005', 'PAX008'], '500': ['PAX005', 'PAX011', 'PAX011'] },
    { '750': ['PAX008', 'PAX020'], '500': ['PAX011', 'PAX011', 'PAX016'] }
  ],
  '750-750-500-500-500-500': [
    { '750': ['PAX010', 'PAX010'], '500': ['PAX010', 'PAX010', 'PAX010', 'PAX010'] },
    { '750': ['PAX008', 'PAX008'], '500': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX008', 'PAX008'], '500': ['PAX001', 'PAX001', 'PAX011', 'PAX011'] },
    { '750': ['PAX008', 'PAX008'], '500': ['PAX001', 'PAX005', 'PAX011', 'PAX011'] }
  ],
  '750-750-750': [
    { '750': ['PAX008', 'PAX008', 'PAX008'] },
    { '750': ['PAX001', 'PAX008', 'PAX008'] },
    { '750': ['PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX013', 'PAX013', 'PAX013'] },
    { '750': ['PAX001', 'PAX001', 'PAX002'] },
    { '750': ['PAX002', 'PAX002', 'PAX002'] }
  ],
  '750-750-750-500': [
    { '750': ['PAX008', 'PAX008', 'PAX008'], '500': ['PAX008'] },
    { '750': ['PAX001', 'PAX001', 'PAX001'], '500': ['PAX013'] },
    { '750': ['PAX001', 'PAX001', 'PAX001'], '500': ['PAX001'] },
    { '750': ['PAX006', 'PAX006', 'PAX006'], '500': ['PAX001'] },
    { '750': ['PAX001', 'PAX008', 'PAX018'], '500': ['PAX016'] },
    { '750': ['PAX002', 'PAX002', 'PAX002'], '500': ['PAX002'] },
    { '750': ['PAX008', 'PAX008', 'PAX015'], '500': ['PAX016'] },
    { '750': ['PAX006', 'PAX007', 'PAX012'], '500': ['PAX006'] }
  ],
  '750-750-750-500-500': [
    { '750': ['PAX011', 'PAX011', 'PAX011'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX008', 'PAX008', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX008', 'PAX008'], '500': ['PAX016', 'PAX016'] },
    { '750': ['PAX004', 'PAX004', 'PAX013'], '500': ['PAX004', 'PAX005'] },
    { '750': ['PAX001', 'PAX003', 'PAX004'], '500': ['PAX013', 'PAX016'] },
    { '750': ['PAX001', 'PAX011', 'PAX021'], '500': ['PAX012', 'PAX012'] },
    { '750': ['PAX001', 'PAX013', 'PAX013'], '500': ['PAX001', 'PAX013'] },
    { '750': ['PAX001', 'PAX001', 'PAX001'], '500': ['PAX001', 'PAX001'] }
  ],
  '750-750-750-500-500-500': [
    { '750': ['PAX008', 'PAX008', 'PAX021'], '500': ['PAX011', 'PAX011', 'PAX021'] }
  ],
  '750-750-750-750': [
    { '750': ['PAX008', 'PAX008', 'PAX008', 'PAX008'] },
    { '750': ['PAX001', 'PAX001', 'PAX008', 'PAX008'] },
    { '750': ['PAX011', 'PAX011', 'PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX001', 'PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX001', 'PAX002', 'PAX002'] },
    { '750': ['PAX001', 'PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX002', 'PAX002', 'PAX002', 'PAX002'] },
    { '750': ['PAX001', 'PAX001', 'PAX021', 'PAX021'] }
  ],
  '750-750-750-750-500': [
    { '750': ['PAX001', 'PAX001', 'PAX008', 'PAX008'], '500': ['PAX011'] },
    { '750': ['PAX001', 'PAX001', 'PAX016', 'PAX016'], '500': ['PAX011'] },
    { '750': ['PAX013', 'PAX013', 'PAX013', 'PAX013'], '500': ['PAX013'] },
    { '750': ['PAX021', 'PAX021', 'PAX021', 'PAX021'], '500': ['PAX011'] },
    { '750': ['PAX001', 'PAX005', 'PAX005', 'PAX013'], '500': ['PAX011'] },
    { '750': ['PAX002', 'PAX002', 'PAX008', 'PAX008'], '500': ['PAX011'] },
    { '750': ['PAX002', 'PAX002', 'PAX002', 'PAX002'], '500': ['PAX016'] },
    { '750': ['PAX008', 'PAX011', 'PAX012', 'PAX016'], '500': ['PAX011'] }
  ],
  '750-750-750-750-500-500': [
    { '750': ['PAX002', 'PAX002', 'PAX005', 'PAX005'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX001', 'PAX002', 'PAX008'], '500': ['PAX011', 'PAX011'] },
    { '750': ['PAX001', 'PAX002', 'PAX002', 'PAX013'], '500': ['PAX011', 'PAX011'] }
  ],
  '750-750-750-750-750': [
    { '750': ['PAX001', 'PAX001', 'PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX016', 'PAX016', 'PAX016', 'PAX016', 'PAX016'] },
    { '750': ['PAX021', 'PAX021', 'PAX021', 'PAX021', 'PAX021'] },
    { '750': ['PAX006', 'PAX006', 'PAX006', 'PAX011', 'PAX013'] },
    { '750': ['PAX011', 'PAX011', 'PAX011', 'PAX013', 'PAX013'] },
    { '750': ['PAX001', 'PAX001', 'PAX001', 'PAX005', 'PAX016'] },
    { '750': ['PAX001', 'PAX002', 'PAX002', 'PAX010', 'PAX011'] },
    { '750': ['PAX004', 'PAX004', 'PAX008', 'PAX008', 'PAX016'] }
  ],
  '750-750-750-750-750-750': [
    { '750': ['PAX001', 'PAX001', 'PAX001', 'PAX001', 'PAX001', 'PAX001'] },
    { '750': ['PAX001', 'PAX001', 'PAX008', 'PAX008', 'PAX012', 'PAX012'] }
  ]
} as InteriorSuggestionRules;
